<template>
  <Modal @close="close">
    <div class="modal__shields">
      <ModalShield icon="prizeLocked" />
    </div>

    <h1 v-if="levelId === 1">
      Найдите и одолейте короля Алланта.
    </h1>
    <h1 v-if="levelId === 2">
      Спасите Элли от кликера. <br />У вас есть 5 ходов!
    </h1>
    <h1 v-if="levelId === 3">
      Наберите 1000 ед. атаки.
    </h1>
  </Modal>
</template>

<script>
import { mapState } from "vuex";
import Modal from "./Modal";
import ModalShield from "./ModalShield";

export default {
  components: { Modal, ModalShield },
  computed: {
    ...mapState(["levelId"])
  },
  methods: {
    close() {
      this.$store.commit("toggleModal", "currentTask");
    }
  }
};
</script>
